//
// RoleMetadata.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./Role";

var RoleMetadata = createModule("gtl_RoleMetadata", [20358], EventDispatcher, [
    ,
    ,
    ,
    ,
    {
        getAllRoles: [[1]],
        getXAxesRoles: [[1]],
        getXAxisRoles: [[1]],
        getY2AxisRoles: [[1]],
        getYAxesRoles: [[1]],
        getXAxisRoleNames: [[7]],
        getYAxisRoleNames: [[7]],
        getX2AxisRoles: [[1]],
        getYAxisRoles: [[1]],
        getDiscreteLegendRoles: [[1]],
    },
    ,
    ,
]);
export default RoleMetadata;
